import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import {
  PermissionSetService,
  TenantPermissionAssigneeTargetLinkService,
  UserAppletService,
  PermissionInquiryService,
} from "blg-akaun-ts-lib";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "../../../../visa";
import { of } from "rxjs";
import { exhaustMap, map, catchError } from "rxjs/operators";
import { PermissionStates } from "../../permission-controller/root";
import { UserPermInquriyActions } from "../actions";

@Injectable()
export class UserPermInquiryEffects {
  private readonly apiVisa = AppConfig.apiVisa;

  permissionInquiry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserPermInquriyActions.loadUserPermissionInquiryInit),
      exhaustMap((action) =>
        this.permissionInquiryService.post(action.request, this.apiVisa).pipe(
          map((result) =>
            UserPermInquriyActions.loadUserPermissionInquirySuccess({
              response: result.data,
            })
          ),
          catchError((error) =>
            of(
              UserPermInquriyActions.loadUserPermisisonInquiryFailure({ error })
            )
          )
        )
      )
    )
  );

  constructor(
    private store: Store<PermissionStates>,
    private actions$: Actions,
    private toaster: ToastrService,
    private permissionInquiryService: PermissionInquiryService
  ) {}

  /**
   * Display a successful toaster message.
   *
   * @param message : the message to display
   * @returns the toaster
   */
  displayToasterSuccess(message: string) {
    return this.toaster.success(message, "Success", {
      tapToDismiss: true,
      progressBar: true,
      timeOut: 1300,
    });
  }

  /**
   * Display a toaster when there is an error.
   *
   * @param message : the messsage to display
   * @returns the toaster
   */
  displayToasterError(message: string) {
    return this.toaster.error(message, "Error", {
      tapToDismiss: true,
      progressBar: true,
      timeOut: 1300,
    });
  }
}
